// import React from 'react';

import React, { useState } from 'react'
import { Button, Typography, Box, Stack, useTheme } from '@mui/material';
import BackButton from '../../../components/BackButton';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import BgBoxOld from '../../../components/BgBoxOld';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { useEffect } from 'react';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import { isNotEmpty } from '../../../utils/format';
import AttachFileUpload from '../../../components/AttachFileUpload';
import { editNewProdReqServ, getSingleNewProdReqServ } from '../../../services/newprodreq-service';
import NotesMdl from '../../../components/NotesMdl';

function EditNewProdReqPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { setLoadingScreen } = useAuthContext();
  const location = useLocation();
  const { newProdReqId } = location.state || {};
  const [formErrors, setFormErrors] = useState({});
  const queryClient = useQueryClient();
  const [payload, setPayload] = useState(null)
  const { isLoading, isError, error, data: reqData } = useQuery([QueryKey.singleNewProdReq, newProdReqId],
    () => getSingleNewProdReqServ(newProdReqId),
    {
      enabled: isNotEmpty(newProdReqId),
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    });
  const txtFieldSx = { width: "100%", height: 30, borderRadius: 1 }
  const [attchs, setAttchs] = useState([]);
  const [notesMdl, setNotesMdl] = useState(false);
  const handleNotesMdlClose = () => setNotesMdl(false);

  useEffect(() => {
    setLoadingScreen(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  useEffect(() => {
    if (!reqData)
      return
    else if (!reqData?.attachFiles)
      return
    else
      setData(reqData)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reqData])

  function setData(data) {
    const attchArr = (data?.attachFiles || []).map((i) => ({ fileKey: i.attachFile, fileUrl: i.fileUrl, fileName: i.fileName }));
    setAttchs(attchArr)
  }

  function handleFileRemove(index) {
    const updatedImages = attchs.filter((_, i) => i !== index);
    setAttchs(updatedImages);
  };

  function handleOnFileUpload(uploadedFiles) {
    setAttchs(prev => [...prev, ...uploadedFiles])
  }

  async function handleMdlSave({ editRemarks }) {
    setNotesMdl(false)
    setLoadingScreen(true);
    try {
      const reqBody = {
        editRemarks, ...payload
      }
      const { message } = await editNewProdReqServ(reqBody, newProdReqId);
      queryClient.invalidateQueries();
      notify("success", message);
      navigate(`${route.cNewProdreqinfo}/?newProdReqId=${newProdReqId}`, { replace: true });
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
    let errorsObj = validate(inputObject);
    setFormErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0)
      return;

    const payload = {
      mailSubject: inputObject.mailSubject,
      mailContent: inputObject.mailContent,
      attachArr: attchs.map((i) => ({ attachFile: i.fileKey, fileName: i.fileName }))
    }
    setPayload(payload);
    setNotesMdl(true);
  };



  function validate(values) {
    const errors = {};
    if (!values.mailSubject)
      errors.mailSubject = "Subject is required!";
    if (!values.mailContent)
      errors.mailContent = "Description is required!";

    return errors;
  };

  async function handleCancel() {
    navigate(`${route.cNewProdreqinfo}/?newProdReqId=${newProdReqId}`, { replace: true });
  }



  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  return (
    <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%", position: "relative" }}>
      <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5}>
        <BackButton />
        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Edit New Product Request</Typography>
        <Box />
      </Stack>
      {reqData && <BgBoxOld height={"93%"} py={1}>
        <Stack gap={1} mt={1}>
          <LabelTxtFieldInfo defaultValue={reqData?.mailSubject} name="mailSubject" errMsg={formErrors.mailSubject} title="Subject *" {...txtFieldSx} />
          <LabelTxtFieldInfo defaultValue={reqData?.mailContent} name="mailContent" errMsg={formErrors.mailContent} title="Description *" {...txtFieldSx}
            rows={14} multiline={true} height={250} />
          <AttachFileUpload title={"Attachments"} height={100} width={"100%"} filesArr={attchs} onUpload={handleOnFileUpload} onRemove={handleFileRemove} />
        </Stack>

      </BgBoxOld>}

      <Box sx={{ position: "absolute", bottom: 20, right: 20 }}>
        <Button variant="outlined" onClick={handleCancel} sx={{
          fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
          color: theme.palette.custom.btn, mr: 2,
        }}>CANCEL</Button>
        <Button variant="contained" type="submit"
          sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>SAVE</Button>
      </Box>
      {payload && <NotesMdl modalOpen={notesMdl} handleModalClose={handleNotesMdlClose} handleMdlSave={handleMdlSave} payload={payload} />}
    </form>
  );
}

export default EditNewProdReqPage;